import React, { useState } from 'react'
import { Container, Row, Col, Alert, Image } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
	faCircleCheck,
	faCircleXmark,
} from '@fortawesome/free-regular-svg-icons'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { Switch } from '../../../../components/ui/Switch'
import './MarketingConsent.scss'
import { Trans, useTranslation } from 'react-i18next'
import { useSspContext } from 'selfServicePortal/hooks/useSspContext'
import useUpdateMarketingConsent from 'selfServicePortal/hooks/useUpdateMarketingConsent'
import marketingConsentImage from 'img/marketing-consent.png'

const MarketingConsent = () => {
	const { t } = useTranslation()
	const { customerData } = useSspContext()
	const [allowMarketingConsent, setAllowMarketingConsent] = useState(
		customerData?.allowMarketingConsent ?? false,
	)
	const [alert, setAlert] = useState<{
		show: boolean
		variant: 'success' | 'danger'
		message: string
	}>({ show: false, variant: 'success', message: '' })
	const updateMarketingConsent = useUpdateMarketingConsent(t)

	const handleSwitchChange = () => {
		const newConsentStatus = !allowMarketingConsent
		setAllowMarketingConsent(newConsentStatus)
		updateMarketingConsent.mutate(
			{
				partyId: customerData?.customerId!,
				allowMarketingConsent: newConsentStatus,
			},
			{
				onSuccess: () => {
					setAlert({
						show: true,
						variant: 'success',
						message: t('MarketingConsent.successMessage'),
					})
					setTimeout(() => setAlert({ ...alert, show: false }), 5000)
				},
				onError: () => {
					setAlert({
						show: true,
						variant: 'danger',
						message: t('MarketingConsent.errorMessage'),
					})
					setTimeout(() => setAlert({ ...alert, show: false }), 5000)
					setAllowMarketingConsent(!newConsentStatus)
				},
			},
		)
	}

	const icon = allowMarketingConsent ? faCircleCheck : faCircleXmark

	return (
		<Container
			fluid
			className="d-flex justify-content-center align-items-center full-width-container">
			<Row className="justify-content-center w-100 mb-4 mobile-margin-top">
				<Col md={8}>
					<Container className="marketing-consent-container">
						<h2 className="text-center">
							{t('MarketingConsent.title')}
						</h2>
						<Row className="pt-4">
							<Col xs={12} md={8}>
								<Trans
									i18nKey="MarketingConsent.description"
									components={[<a target="_blank" href={t('MarketingConsent.linkUrl')} rel="noopener noreferrer">{t('MarketingConsent.linkText')}</a>]}
								/>
								<div className="d-flex mt-4 switch-container">
									<span>
										<FontAwesomeIcon
											icon={icon as IconProp}
											className="icon-color fa-lg mr-2"
										/>
									</span>
									<span className="mr-2">
										{t('MarketingConsent.status')}
										<strong className="ml-1">
											{allowMarketingConsent
												? t('MarketingConsent.enabled')
												: t(
														'MarketingConsent.disabled',
												  )}
										</strong>
									</span>
									<Switch.Container>
										<Switch.Field
											width={45}
											height={20}
											handleDiameter={18}
											checked={allowMarketingConsent}
											onChange={handleSwitchChange}
										/>
									</Switch.Container>
								</div>
							</Col>
							<Col
								md={4}
								className="d-none d-md-flex justify-content-center align-items-center">
								<div className="marketing-consent-image-placeholder">
									<Image
										src={marketingConsentImage}
										alt="Marketing consent"
									/>
								</div>
							</Col>
						</Row>
					</Container>
				</Col>
			</Row>
			{alert.show && (
				<Alert
					variant={alert.variant}
					onClose={() => setAlert({ ...alert, show: false })}
					dismissible
					className="alert-floating">
					{alert.message}
				</Alert>
			)}
		</Container>
	)
}

export default MarketingConsent
